(function (window) {
  /**
   * Creates the HTML for pagination on InfoBoxes. It creates a previous and
   * next arrow and creates the text saying your location like "1 of 5".
   *
   * @return {string} The HTML, if any, for infobox pagination
   */
  var createInfoWinPagHtml = function () {
    var paginationCluster =
      BatchGeoStore.getState().MapsMarkersManager.paginationCluster;
    var currentPaginationNumber =
      BatchGeoStore.getState().MapsMarkersManager.currentPaginationNumber;

    if (paginationCluster.length > 1) {
      return $("<div />", {
        class: "pg",
        html: [
          currentPaginationNumber + 1 + " of " + paginationCluster.length,
          $("<span />", {
            "data-icon": "<",
            class: "previous pg-arrow icon-keyboard-arrow-left",
          }),
          $("<span />", {
            "data-icon": ">",
            class: "next pg-arrow icon-keyboard-arrow-right",
          }),
        ],
      })[0].outerHTML;
    } else {
      return "";
    }
  };

  /**
   * Figures out if you're in a cluster of markers, and if so, creates map
   * markers for each of those markers in the cluster so that we can get the
   * info for each of them. It returns the pagination HTML.
   *
   * @param {number} row The ID of the marker to figure out if it is in a
   * cluster
   *
   * @param {function} [newClusterCallback] A callback that is fired if we're in
   * a paginating state
   *
   * @return {string} The HTML, if any, for infobox pagination
   */
  var BatchGeoInfoWindowPage = function (row, newClusterCallback) {
    newClusterCallback = newClusterCallback || function () {};
    var markersData = window.batchGeoGoogleMapsManager.settings.markersData;

    //Only regenerate the cluster array if we are not paginating the current
    //cluster.
    if (!BatchGeoStore.getState().MapsMarkersManager.paginating) {
      var rM = markersData.mapRS[row];
      var paginationCluster = [];
      if (
        window.batchGeoGoogleMapsMarker.getMarkersObjArray()[row] !== undefined
      ) {
        paginationCluster[0] =
          window.batchGeoGoogleMapsMarker.getMarkersObjArray()[row];
      }
      window.batchGeoGoogleMapsMarker
        .getMarkersObjArray()
        .forEach(function (cluster, i) {
          if (
            cluster &&
            row != i &&
            BatchGeo.distance2(rM.lt, rM.ln, cluster.Lat, cluster.Lon) < 0.0001
          ) {
            paginationCluster[paginationCluster.length] = cluster;
            // we are in cluster mode so markers havent been fully created yet, do that now
            if (!cluster.marker.desc) {
              cluster.marker =
                window.batchGeoGoogleMapsMarker.MarkerContent.createMapMarker(
                  cluster.marker,
                  cluster.marker.r,
                );
            }
          }
        });

      newClusterCallback(paginationCluster);
    }
    return createInfoWinPagHtml();
  };

  window.BatchGeoInfoWindowPage = BatchGeoInfoWindowPage;
})(window);
